@let search = search$ | async;
<pds-module-header title="Simulação de Busca">
  <h2 class="mb-12">Autorização</h2>
  <pds-panel>
    <peca-search-authorization />
  </pds-panel>

  @if (credentials$ | async){
  <h2 class="mb-12">Busca</h2>
  <pds-panel>
    <pds-form [formGroup]="form">
      <pds-form>
        <pds-form-row grid="1-1-2">
          <pds-form-field label="CEP">
            <input type="text" formControlName="zipcode" placeholder="13000-000" />
          </pds-form-field>
          <pds-form-field label="Placa">
            <input type="text" formControlName="plate" placeholder="ABC1234" />
          </pds-form-field>
          <pds-form-field label="Dialeto">
            <input type="text" formControlName="dialect" placeholder="burrinho do freio dianeito" />
          </pds-form-field>
        </pds-form-row>
      </pds-form>

      <pds-form-actions>
        <button pdsButton="primary" type="button" (click)="onClickClearFilter()">Limpar filtros</button>
        <button pdsButton type="submit" (click)="onClickSearch()">Buscar</button>
      </pds-form-actions>
    </pds-form>
  </pds-panel>
  }

  <peca-search-dialect-details [dialect$]="dialect$" />

  <hr />
  @if (search?.data && search?.data?.products && search?.data?.products?.length) {
  <div>
    @for (item of search?.data?.products; track $index) {
    <div>
      @if (!item.possibilities || !item.possibilities.length) {
      <h4>Nenhum produto encontrado.</h4>
      }
    </div>
    <div class="product-list">
      @for (product of item.possibilities; track $index) {
      <div class="product">
        <div class="product__image">
          <img [src]="product.image || 'https://assets.peca.ai/parts/media/home/default_box.png'" [alt]="product.description" />
        </div>
        <div class="product__headline">
          <h4 class="product__headline__name">{{ product.description }} - {{ product.amount }} UNID</h4>
          <div class="product__headline__price">{{ product.productTotalPrice | currency : 'BRL' }}</div>
        </div>
        <ul class="product__specs">
          <li>
            <strong>Part Number</strong>
            <span>{{ product.partNumber }}</span>
          </li>
          <li>
            <strong>Marca</strong>
            <span>{{ product.brand }}</span>
          </li>
          <li>
            <strong>Frete</strong>
            <span>{{ product.shippingPrice | currency : 'BRL' }}</span>
          </li>
          <li>
            <strong>Promessa</strong>
            <span>{{ product.deadlineHours }}h</span>
          </li>
          <li>
            <strong>Entrega</strong>
            <span>{{ product.expectedDelivery | date : 'dd/MM/yyyy hh:mm' }}</span>
          </li>
        </ul>
      </div>
      }
    </div>
    }
  </div>
  } @else if (search?.loading) {
  <h4>Carregando...</h4>
  }
</pds-module-header>
